import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sCQLotsControllerEndpoint = 'NegotiationCQLots';


export class NegotiationCQlotsAPI {

  getNegotiationCQLotByL2Id(L2Id) {
    return axios.get(getBackendURL() + sCQLotsControllerEndpoint + '/GetL3ListByL2Id?L2Id=' + L2Id);
  }

  saveNewNegotiationCQ(dto) {
    return axios.post(getBackendURL() + sCQLotsControllerEndpoint + '/CreateL3', dto);
  }

  saveEditNegotiationCQ(dto) {
    return axios.put(getBackendURL() + sCQLotsControllerEndpoint + '/UpdateL3', dto);
  }

  deleteNegotiationCQ(L3Id) {
    return axios.delete(getBackendURL() + sCQLotsControllerEndpoint + '/DeleteL3?L3Id=' + L3Id);
  }

}

export default NegotiationCQlotsAPI


// WEBPACK FOOTER //
// ./src/API/NegotiationCQlotsAPI.js